import * as Sentry from '@sentry/react'

const dsn = process.env.SENTRY_DSN;
//Overridable env for sentry environment, that can be development for an alpha stage for instance
const environment = process.env.SENTRY_ENV || process.env.NODE_ENV;

if (!dsn) {
  console.error(
    'Missing SENTRY_DSN environment variable. Did you forget to add it to ' +
      'your redwood.toml file in `includeEnvironmentVariables`?'
  )
  console.info(`Copy this into your redwood.toml file:`)
  console.info(`
  includeEnvironmentVariables = [
    "SENTRY_DSN"
  ]

  `)
  console.info('Sentry is disabled for now')
} else {

Sentry.init({
  dsn,
  environment,
  ignoreErrors: [
    "Cannot read properties of undefined (reading 'x')"
  ],
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllInputs: false,
      maskAllText: false,
      blockAllMedia: false,
    }),
    Sentry.consoleLoggingIntegration({ levels: ["error"] }),
  ],
  enableLogs: true, 
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [process.env.APP_PUBLIC_URL],
  tracesSampleRate: 1.0,
  // Session Replay
  replaysSessionSampleRate: 0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})
}
export default Sentry
